import React from 'react'
import Common from '../components/Common'
import Footer from '../components/Footer'
import ServicesPage from '../services/ServicesPage'
export default function Services() {
  return (
    <div>
      <Common/>
      <ServicesPage/>
      <Footer/>
    </div>
  )
}
